import { IconProps } from '@components/Icons/Menu/index';

const defaultSize = 24;

export const HeadsetIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 8.625C7.5 7.93477 6.94023 7.375 6.25 7.375H5.625C4.24414 7.375 3.125 8.49414 3.125 9.875V11.75C3.125 13.1309 4.24414 14.25 5.625 14.25H6.25C6.94023 14.25 7.5 13.6902 7.5 13V8.625ZM14.375 14.25C15.7559 14.25 16.875 13.1309 16.875 11.75V9.875C16.875 8.49414 15.7559 7.375 14.375 7.375H13.75C13.0598 7.375 12.5 7.93477 12.5 8.625V13C12.5 13.6902 13.0598 14.25 13.75 14.25H14.375ZM10 0.5C4.42109 0.5 0.178906 5.1418 0 10.5V11.125C0 11.4703 0.279687 11.75 0.625 11.75H1.25C1.59531 11.75 1.875 11.4703 1.875 11.125V10.5C1.875 6.01992 5.51992 2.375 10 2.375C14.4801 2.375 18.125 6.01992 18.125 10.5H18.1203C18.1234 10.5949 18.125 16.9734 18.125 16.9734C18.125 17.8855 17.3855 18.625 16.4734 18.625H12.5C12.5 17.5895 11.6605 16.75 10.625 16.75H9.375C8.33945 16.75 7.5 17.5895 7.5 18.625C7.5 19.6605 8.33945 20.5 9.375 20.5H16.4734C18.4211 20.5 20 18.9211 20 16.9734V10.5C19.8211 5.1418 15.5789 0.5 10 0.5Z"
        fill="white"
      />
    </svg>
  );
};
